<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/dgin/index"
          >Manage GIN</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        >{{ gin.gin_num || "View GIN" }}
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-2">
          <button
            v-if="gin.status === 1"
            @click="confirmGin"
            class="btn btn-sm btn-outline-primary bdr-rad mr-1"
          >
            Confirm</button
          ><button
            v-if="gin.status === 3"
            @click="createInvoice"
            class="btn btn-sm btn-outline-primary bdr-rad mr-1"
          >
            Create Invoice</button
          ><button
            @click="$router.push('/dgin/index')"
            class="btn btn-sm btn-outline-primary bdr-rad"
          >
            Back
          </button>
        </div>
        <div class="card bdr-rad2 shadow p-2" v-if="isLoading">
          <div class="card-body text-center">
            <div class="spinner-border text-primary"></div>
          </div>
        </div>
        <div v-else>
          <div class="card bdr-rad2 shadow p-2">
            <div class="card-body">
              <table
                class="table table-hover table-sm table-borderless detail-table"
              >
                <tbody>
                  <tr>
                    <td><b>GIN No.</b></td>
                    <td>{{ gin.gin_num }}</td>
                  </tr>
                  <tr>
                    <td><b>SO No.</b></td>
                    <td>{{ gin.so_num }}</td>
                  </tr>
                  <tr>
                    <td><b>Issued To</b></td>
                    <td>{{ gin.issued_to }}</td>
                  </tr>
                  <tr>
                    <td><b>Issue Date</b></td>
                    <td>{{ gin.issue_date }}</td>
                  </tr>
                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ gin.status_name }}</td>
                  </tr>
                  <tr>
                    <td><b>Remarks</b></td>
                    <td>{{ gin.remarks || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Created Date</b></td>
                    <td>{{ gin.created_date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card bdr-rad2 shadow p-2 mt-3">
            <div class="card-body">
              <h6 class="purchitem mb-2"><b>GIN Items</b></h6>
              <div class="table-responsive">
                <table
                  class="table table-hover table-sm table-borderless gin-items-table"
                >
                  <thead class="background_color2">
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Inventory ID</th>
                      <th class="text_right">Available Qty</th>
                      <th class="text_right">SO Qty</th>
                      <th class="text_right">GIN Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in details" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.product_name }} ({{ item.sku }})</td>
                      <td>{{ item.inventory_id || "-" }}</td>
                      <td class="text_right">{{ item.available_qty }}</td>
                      <td class="text_right">{{ item.so_qty }}</td>
                      <td class="text_right">{{ item.gin_qty }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>
<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";
export default {
  components: { TopNavbar, ContentFooter },
  data: () => ({
    token: authService.isLoggedIn(),
    gin: {},
    details: [],
    isLoading: true,
  }),
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const { data } = await axios.get(
          "/dgin/view?id=" + this.$route.query.id,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.gin = data.all_data || {};
        this.details = data.details || [];
      } finally {
        this.isLoading = false;
      }
    },
    createInvoice() {
      this.$router.push("/dinvoice/create?id=" + this.gin.id);
    },
    async confirmGin() {
      if (!window.confirm("Confirm this GIN? Inventory will be reduced."))
        return;
      await axios.post(
        "/dgin/confirm?id=" + this.gin.id,
        {},
        { headers: { Authorization: "Bearer " + this.token } }
      );
      this.load();
    },
  },
};
</script>
<style scoped>
.background_color {
  background: #eaf6ff;
  min-height: calc(100vh - 60px);
}

.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  color: #fff !important;
  text-decoration: none;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  background: #087df5;
  color: #fff;
  padding: 10px 15px !important;
  margin-bottom: 10px;
}

.detail-table,
.gin-items-table {
  font-size: small;
}

.detail-table td:first-child {
  width: 220px;
}

.background_color2 {
  background: #235983;
  color: #fff;
}

.text_right {
  text-align: right;
}
</style>
